<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          公众号管理
          <span class="titleColor"></span> -任务配置
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="发送模版">
          <el-select v-model="listQuery.templateId" clearable class="filter-item" placeholder="请选择模版消息" filterable>
            <el-option v-for="(item, index) in templateList" :key="index" :label="item.name" :value="item.templateId" />
          </el-select>
        </el-form-item>
        <el-form-item label="通知类型">
          <el-select v-model="listQuery.noticeType" clearable placeholder="请选择" clear filterable>
            <el-option v-for="(item, index) in typeList" :key="index"
              :label="'(' + item.type + ')' + item.title + ',' + item.noticeType" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="定时任务名称">
          <el-input v-model="listQuery.jobName" placeholder="定时任务名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="发送频率">
          <el-select v-model="listQuery.timedTask" clearable class="filter-item" placeholder="请选择发送时间" filterable>
            <el-option v-for="(item, index) in timedTaskMap" :key="index" :label="item" :value="index" />
          </el-select>
        </el-form-item>

        <el-form-item label="是否启用">
          <el-select v-model="listQuery.deleted" class="filter-item" placeholder="是否启用">
            <el-option label="启用" value="false" />
            <el-option label="停用" value="true" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-icon-plus" plan @click="addNewTask">新建任务</el-button>

          <el-button style="margin-left:300px;" type="warning" plan @click="erfUser">同步公众号用户</el-button>
        </el-form-item>
      </el-form>
      <!-- 新增 -->
      <!-- <el-row class="btn-margin">
      
      </el-row>-->
      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="id" width="100" label="编号" fixed></el-table-column>
        <el-table-column prop="jobName" label="任务名称"></el-table-column>

        <el-table-column prop="templateId" label="模版id"></el-table-column>
        <el-table-column prop="templateName" label="模版名称"></el-table-column>
        <el-table-column prop="pushRange" label="发送范围">
          <template slot-scope="scope">
            {{ rangeList[scope.row.pushRange] }}
          </template>
        </el-table-column>
        <el-table-column prop="settingCron" width="120" label="定时表达式"></el-table-column>
        <el-table-column prop="labelsNames" label="数据标签"></el-table-column>
        <el-table-column prop="customSql" label="自定义sql"></el-table-column>
        <el-table-column prop="resultParmSql" label="sql数据映射" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushRange" label="发送频率">
          <template slot-scope="scope">
            {{ timedTaskMap[scope.row.timedTask] }}
          </template>
        </el-table-column>
        <el-table-column prop="settingDate" label="发送日期"></el-table-column>
        <el-table-column prop="settingTime" label="发送时间"></el-table-column>
        <el-table-column prop="sendContent" label="发送内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isToMiniApp" label="发送方式">
          <template slot-scope="scope">
            {{ isToMiniAppMap[scope.row.isToMiniApp] }}
          </template>
        </el-table-column>
        <el-table-column prop="isAlert" label="是否需要弹窗">
          <template slot-scope="scope">
            <span>{{ scope.row.isAlert == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isFeedback" label="是否需要填写回执信息">
          <template slot-scope="scope">
            <span>{{ scope.row.isFeedback == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pagePath" label="小程序路径"></el-table-column>
        <el-table-column prop="url" label="消息跳转的h5"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.deleted == false">启用</span>
            <span v-if="scope.row.deleted == true">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
        <el-table-column prop label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" class="textWarning" v-if="scope.row.deleted == false"
              @click="stopBtn(scope.$index, scope.row)">停用</el-button>
            <el-button type="text" v-if="scope.row.deleted == true"
              @click="openBtn(scope.$index, scope.row)">启用</el-button>
            <el-button type="text" @click="editBtn(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />

      <!-- 新增定时任务 -->
      <el-dialog title="新增定时任务" :visible.sync="addVisible" width="700px" center>
        <el-form ref="addTaskForm" :rules="rules" :model="addTaskForm" label-width="160px">
          <el-form-item label="定时任务名称" prop="jobName">
            <el-input v-model="addTaskForm.jobName" placeholder clearable></el-input>
          </el-form-item>

          <el-form-item label="通知类型" prop="noticeType">
            <el-select v-model="addTaskForm.noticeType" clearable placeholder="请选择" clear filterable>
              <el-option v-for="(item, index) in typeList" :key="index"
                :label="'(' + item.type + ')' + item.title + ',' + item.noticeType" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发送方式" prop="isToMiniApp">
            <el-select v-model="addTaskForm.isToMiniApp" clearable placeholder="请选择" clear filterable>
              <el-option v-for="(item, index) in isToMiniAppMap" :key="index" :label="item" :value="index + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发送模版" prop="templateId">
            <el-select v-model="addTaskForm.templateId" @change="selectTP" clearable class="filter-item"
              placeholder="请选择模版消息" filterable>
              <el-option v-for="(item, index) in templateList" :key="index" :label="item.name"
                :value="item.templateId" />
            </el-select>
          </el-form-item>

          <el-form-item label="发送内容" prop="sendContent">
            <el-input type="textarea" v-model="addTaskForm.sendContent" :rows="7" placeholder="若不选择模板请手动填入消息内容"
              class="input-width"></el-input>
          </el-form-item>

          <el-form-item label="发送范围" prop="pushRange">
            <el-select v-model="addTaskForm.pushRange" clearable class="filter-item" placeholder="请选择发送范围" filterable>
              <el-option v-for="(item, index) in rangeList" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>

          <el-form-item label="数据标签" prop="labels" v-if="addTaskForm.pushRange == 1">
            <el-select v-model="addTaskForm.labels" clearable class="filter-item" placeholder="请选择数据标签" filterable
              multiple>
              <el-option v-for="(item, index) in labelList" :key="index" :label="item.labelName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="自定义sql" prop="customSql" v-if="addTaskForm.pushRange == 2">
            <el-input type="textarea" v-model="addTaskForm.customSql" :rows="4"
              placeholder="select worker_no from dual " class="input-width"></el-input>
          </el-form-item>

          <el-form-item label="城市" prop="cityId" v-if="addTaskForm.pushRange == 3">
            <el-select v-model="addTaskForm.cityId" clearable placeholder="请选择城市" @change="cityChange">
              <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityAddress"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择服务者" v-if="addTaskForm.pushRange == 3">
            <el-select v-model="addTaskForm.workerNos" filterable clearable multiple  placeholder="请选择服务者" >
              <el-option v-for="(item, index) in workerList" :key="index" 
              :label="item.workerName+item.workerNo"   :value="item.workerNo"></el-option>
            </el-select>
          </el-form-item> 


          <el-form-item label="发送频率" prop="timedTask">
            <el-select v-model="addTaskForm.timedTask" clearable class="filter-item" placeholder="请选择发送频率" filterable>
              <el-option v-for="(item, index) in timedTaskMap" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送日期" v-if="addTaskForm.timedTask == 1" prop="settingDate">

            <el-date-picker v-model="addTaskForm.settingDate" type="date" value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>

          </el-form-item>
          <el-form-item label="发送日期" v-if="addTaskForm.timedTask == 3" prop="settingDate">
            <el-select v-model="addTaskForm.settingDate" clearable class="filter-item" placeholder="请选择每周几发送"
              filterable>
              <el-option v-for="(item, index) in weekList" :key="index" :label="item.text" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送日期" v-if="addTaskForm.timedTask == 4" prop="settingDate">
            <el-select v-model="addTaskForm.settingDate" clearable class="filter-item" placeholder="请选择每月几号发送"
              filterable>
              <el-option v-for="(item, index) in dayList" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送时间" v-if="addTaskForm.timedTask != 0" prop="settingTime">
            <div class="block">
              <el-time-picker v-model="addTaskForm.settingTime" placeholder="请选择发送时间" value-format="HH:mm:ss"
                format="HH:mm:ss"></el-time-picker>
            </div>
          </el-form-item>

          <el-form-item label="是否需要弹窗">
            <el-select v-model="addTaskForm.isAlert" class="filter-item" placeholder="是否要弹窗提醒">
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否需要填写回执信息">
            <el-select v-model="addTaskForm.isFeedback" class="filter-item" placeholder="是否需要填写回执信息">
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>

          <el-form-item label="选择小程序页面">
            <el-select class="filter-item" v-model="pagess" clearable @change="selectAppPage" placeholder="请选择小程序页面路径">
              <el-option v-for="(item, index) in appPagePathList" :key="index" :label="item.pageName"
                :value="item.pageUrl" />
            </el-select>
          </el-form-item>

          <el-form-item label="小程序路径" prop="pagePath">
            <el-input v-model="addTaskForm.pagePath" placeholder clearable></el-input>
          </el-form-item>
          <el-form-item label="消息跳转的h5" prop="url">
            <el-input v-model="addTaskForm.url" placeholder clearable></el-input>
          </el-form-item>
          <el-form-item label="sql数据映射">
            <el-input type="textarea" v-model="addTaskForm.resultParmSql" :rows="4"
              placeholder="select worker_no,book_order_no from dual where FIND_IN_SET(t.worker_no,?)"
              class="input-width"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddTaskForm('addTaskForm')">取 消</el-button>
          <el-button type="primary" plan @click="confAddTaskForm('addTaskForm')">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑定时任务 -->
      <el-dialog title="编辑定时任务" :visible.sync="editVisible" width="700px" center>
        <el-form ref="editTaskForm" :rules="editRules" :model="editTaskForm" label-width="160px">


          <el-form-item label="任务名称" prop="pagePath">
            <el-input v-model="editTaskForm.jobName" placeholder disabled></el-input>
          </el-form-item>


          <el-form-item label="通知类型" prop="noticeType">
            <el-select v-model="editTaskForm.noticeType" clearable placeholder="请选择" clear filterable>
              <el-option v-for="(item, index) in typeList" :key="index"
                :label="'(' + item.type + ')' + item.title + ',' + item.noticeType" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发送范围" prop="pushRange">
            <el-select v-model="editTaskForm.pushRange" clearable class="filter-item" placeholder="请选择发送范围" filterable>
              <el-option v-for="(item, index) in rangeList" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="数据标签" prop="labels" v-if="editTaskForm.pushRange == 1">
            <el-select v-model="editTaskForm.labels" clearable class="filter-item" placeholder="请选择数据标签" filterable
              multiple>
              <el-option v-for="(item, index) in labelList" :key="index" :label="item.labelName"
                :value="item.id + ''" />
            </el-select>
          </el-form-item>

          <el-form-item label="自定义sql" prop="customSql" v-if="editTaskForm.pushRange == 2">
            <el-input type="textarea" v-model="editTaskForm.customSql" :rows="4"
              placeholder="select worker_no from dual " class="input-width"></el-input>
          </el-form-item>

          <el-form-item label="城市" prop="cityId" v-if="editTaskForm.pushRange == 3">
            <el-select v-model="editTaskForm.cityId" clearable placeholder="请选择城市" @change="cityChange">
              <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityAddress"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择服务者" v-if="editTaskForm.pushRange == 3">
            <el-select v-model="editTaskForm.workerNos" filterable clearable multiple  placeholder="请选择服务者" >
              <el-option v-for="(item, index) in workerList" :key="index" 
              :label="item.workerName+item.workerNo"   :value="item.workerNo"></el-option>
            </el-select>
          </el-form-item> 


          <el-form-item label="发送频率" prop="timedTask">
            <el-select v-model="editTaskForm.timedTask" clearable class="filter-item" placeholder="请选择发送频率" filterable>
              <el-option v-for="(item, index) in timedTaskMap" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送日期" v-if="editTaskForm.timedTask == 1" prop="settingDate">

            <el-date-picker v-model="editTaskForm.settingDate" type="date" value-format="yyyy-MM-dd"
              placeholder="请选择日期"></el-date-picker>

          </el-form-item>
          <el-form-item label="发送日期" v-if="editTaskForm.timedTask == 3" prop="settingDate">
            <el-select v-model="editTaskForm.settingDate" clearable class="filter-item" placeholder="请选择每周几发送"
              filterable>
              <el-option v-for="(item, index) in weekList" :key="index" :label="item.text" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送日期" v-if="editTaskForm.timedTask == 4" prop="settingDate">
            <el-select v-model="editTaskForm.settingDate" clearable class="filter-item" placeholder="请选择每月几号发送"
              filterable>
              <el-option v-for="(item, index) in dayList" :key="index" :label="item" :value="index" />
            </el-select>
          </el-form-item>
          <el-form-item label="发送时间" v-if="editTaskForm.timedTask != 0" prop="settingTime">
            <div class="block">
              <el-time-picker v-model="editTaskForm.settingTime" placeholder="请选择发送时间" value-format="HH:mm:ss"
                format="HH:mm:ss"></el-time-picker>
            </div>
          </el-form-item>

          <el-form-item label="是否需要弹窗">
            <el-select v-model="editTaskForm.isAlert" class="filter-item" placeholder="是否要弹窗提醒">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否需要填写回执信息">
            <el-select v-model="editTaskForm.isFeedback" class="filter-item" placeholder="是否需要填写回执信息">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>

          <el-form-item label="选择小程序页面">
            <el-select class="filter-item" v-model="editTaskForm.pagess" clearable @change="selectAppPageEdit"
              placeholder="请选择小程序页面路径">
              <el-option v-for="(item, index) in appPagePathList" :key="index" :label="item.pageName"
                :value="item.pageUrl" />
            </el-select>
          </el-form-item>

          <el-form-item label="小程序路径" prop="pagePath">
            <el-input v-model="editTaskForm.pagePath" placeholder clearable></el-input>
          </el-form-item>
          <el-form-item label="消息跳转的h5" prop="url">
            <el-input v-model="editTaskForm.url" placeholder clearable></el-input>
          </el-form-item>
          <el-form-item label="sql数据映射">
            <el-input type="textarea" v-model="editTaskForm.resultParmSql" :rows="8"
              placeholder="select worker_no,book_order_no from dual where FIND_IN_SET(t.worker_no,?)"
              class="input-width"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" plan @click="confEditTaskForm('editTaskForm')">确 定</el-button>
        </span>
      </el-dialog>






    </div>
  </div>
</template>
<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import wmsApi from "@/script/api/wmsApi";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
export default {
  components: { Pagination },
  data() {
    return {
      workerList:[],
      cityList: [],
      pagess: '',
      appPagePathList: [],
      isToMiniAppMap: { 1: '小程序', 2: '公众号和小程序' },
      typeList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        jobName: "",
        timedTask: "",
        noticeType: '',
        deleted: ''
      },
      templateList: [],
      timedTaskMap: {
        0: "立即发送",
        1: "定时发送",
        2: "每日循环",
        3: "每周循环",
        4: "每月循环"
      },
      rangeList: { 0: "全部", 1: "指定标签", 2: "自定义sql", 3: "指定服务者" },
      weekList: [
        { text: "周一", value: 1 },
        { text: "周二", value: 2 },
        { text: "周三", value: 3 },
        { text: "周四", value: 4 },
        { text: "周五", value: 5 },
        { text: "周六", value: 6 },
        { text: "周日", value: 7 }
      ],
      dayList: [],
      addVisible: false,
      addTaskForm: {
        jobName: "",
        templateId: "",
        sendContent: "",
        pushRange: "",
        customSql: "",
        timedTask: "",
        labels: [],
        settingDate: "",
        settingTime: '',
        isToMiniApp: '1',
        noticeType: "",
        pagePath: '',
        url: '',
        resultParmSql: '',
        isAlert: '0',
        isFeedback: '0',
        cityId: '',
        workerNos:'',
      },
      labelList: [],
      editVisible: false,
      editTaskForm: {

      },
      editRules: {
             settingTime: [
          { required: true, message: "请选择发送时间", trigger: "change" }
        ],
      },

      rules: {
        jobName: [
          { required: true, message: "请输入任务名称", trigger: "change" }
        ],
        pushRange: [
          { required: true, message: "请选择发送范围", trigger: "change" }
        ],
        isToMiniApp: [
          { required: true, message: "请选择发送方式", trigger: "change" }
        ],
        noticeType: [
          { required: true, message: "请选择通知类型", trigger: "change" }
        ],

        // templateId: [
        //   { required: true, message: "请选择模版", trigger: "change" }
        // ],


      },
    };
  },
  created() {
    this.getAllCity();

    this.getTypeData();
    let list = [];
    for (let i = 1; i <= 31; i++) {
      list.push(i);
    }
    this.dayList = list;
    this.querySearch();
    this.getGzhTemplate();

    service.$axioDimMpGetAll({}).then(res => {
      console.log(res);
      if (res.data.errno == 0) {
        this.labelList = res.data.data;
      } else {
        this.$message.warning(res.data.data);
      }
    });
    this.getAppPagelist();
  },
  methods: {
    cityChange(){
      this.queryWorkerSearch();
    },
    queryWorkerSearch() {
      let req = {
        selectType: 1,//我的服务者
        fieldType: 1,//指定字段
        state: 2,//在职状态
        cityId: this.addTaskForm.cityId,
        postStationId: null,
        stationId: null,
        workerNo: null,
        workerName: null,
        label: null,
        userId: globalData.userInfo.id,
        pageSize: 99999,
        pageNum: 1,
      };
      workercrmapi.$axiosGetWorkerList(req).then((res) => {
        if (res.data.errno == 0) {
          this.workerList = res.data.data.list;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi
        .$axiosgetallCity({ userId: globalData.userInfo.id })
        .then((res) => {
          if (res.data.errno == 0) {
            this.cityList = res.data.data;
          }
        });
    },
    getAppPagelist() {
      service.$axioGetAppPagelist().then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.appPagePathList = res.data.data;
        }
      });
    },
    selectAppPage(url) {
      this.addTaskForm.pagePath = url;
    },
    selectAppPageEdit(url) {
      this.editTaskForm.pagePath = url;
    },
    selectTP(templateId) {
      this.addTaskForm.sendContent = "";
      this.templateList.forEach(e => {
        if (e.templateId == templateId) {
          this.addTaskForm.sendContent = e.content;
        }
      })
    },
    getGzhTemplate() {
      service.$axioWxMpGetAll({}).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.templateList = res.data.data;
        } else {
          this.$message.warning(res.data.data);
        }
      });
    },
    getTypeData() {
      service.$axioWorkerNoticeGetTypelist({ level: 2 }).then((res) => {
        if (res.data.errno == 0) {
          this.typeList = res.data.data;
        }
      })
    },
    erfUser() {
      service
        .$axioWxSyncAllWxUser()
        .then(res => {
          console.log(res);
          this.$message.success("同步成功");
        })
        .catch(err => {
          console.log(err);
        });
    },
    //查询
    querySearch() {
      service
        .$axioWxMpJobList({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          timedTask: this.listQuery.timedTask,
          jobName: this.listQuery.jobName,
          deleted: this.listQuery.deleted,
          templateId: this.listQuery.templateId,
          noticeType: this.listQuery.noticeType,
        })
        .then(res => {
          console.log(res);
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //取消新增并重置
    cancelAddTaskForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.addVisible = false;
    },
    //确定新增
    confAddTaskForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.addTaskForm));
          let labels = params.labels;
          let item = this.templateList.filter(item => { return item.templateId == this.addTaskForm.templateId });

          if(this.addTaskForm.workerNos.length>0){
           params.workerNos=this.addTaskForm.workerNos.join(',');
          }else{
            params.workerNos='';
          }
          params.labels = labels.join(',');
          params.createUser = globalData.userInfo.id;
          params.templateName = item[0].name;
          console.log(params);
          service.$axioWxAddJob(params).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addVisible = false;
              this.querySearch();
            } else {
              this.$message.warning(res.data.data);
            }
          });
        } else {
          console.log("err");
        }
      });
    },
    confEditTaskForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
      let params = {
        id: this.editTaskForm.id,
        pushRange: this.editTaskForm.pushRange,
        labels: this.editTaskForm.labels.join(','),
        isAlert: this.editTaskForm.isAlert,
        isFeedback: this.editTaskForm.isFeedback,
        pagePath: this.editTaskForm.pagePath,
        url: this.editTaskForm.url,
        customSql: this.editTaskForm.customSql,
        resultParmSql: this.editTaskForm.resultParmSql,
        noticeType: this.editTaskForm.noticeType,
        workerNos:this.editTaskForm.workerNos.join(','),
        timedTask: this.editTaskForm.timedTask,
        settingDate: this.editTaskForm.settingDate,
        settingTime: this.editTaskForm.settingTime,
      };
      service.$axioWxUpdateJob(params).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.$message.success("编辑成功");
          this.editVisible = false;
          this.querySearch();
        } else {
          this.$message.warning(res.data.data);
        }
      });
       } else {
          console.log("err");
        }
      });
    },
    //新增消息模版
    addNewTask() {
      this.addVisible = true;
      this.addTaskForm = {
        jobName: "",
        templateId: "",
        pushRange: "",
        customSql: "",
        timedTask: "",
        labels: [],
        settingDate: "",
        settingTime: '',
        isToMiniApp: '1',
        pagePath: '',
        url: '',
        isAlert: '0',
        isFeedback: '0',
        sendContent: '',
        cityId: '',
        workerNos:'',
      };
      // this.getAppPagelist();
    },


    //停用确认框
    stopBtn(index, row) {
      this.$confirm("您确定停用吗？")
        .then(_ => {
          this.confStop(row.id);
        })
        .catch(_ => { });
    },
    //启用确认框
    openBtn(index, row) {
      this.$confirm("您确定启用吗？")
        .then(_ => {
          this.confOpen(row.id);
        })
        .catch(_ => { });
    },
    editBtn(row) {
      this.editTaskForm = row;
      this.editTaskForm.pushRange = row.pushRange + '';
      if (row.pushRange == 1 && row.labels != '') {
        this.editTaskForm.labels = row.labels.split(',');
      } else {
        this.editTaskForm.labels = [];
      }

      if(row.workerNos!=''){
        this.editTaskForm.workerNos =  row.workerNos.split(',');
      }else{
        this.editTaskForm.workerNos = [];
      }
    this.editTaskForm.timedTask=row.timedTask+'';
      this.editVisible = true;
      //  this.getAppPagelist();
    },
    confOpen(id) {
      service
        .$axioWxMpJobDel({
          id: id,
          deleted: false
        })
        .then(res => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.querySearch();
          } else {
            this.$message.warning(res.data.errmsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    confStop(id) {
      service
        .$axioWxMpJobDel({
          id: id,
          deleted: true
        })
        .then(res => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.querySearch();
          } else {
            this.$message.warning(res.data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
<style scoped>
.el-form {
  padding: 0 60px 0 20px !important;
}

.el-select.el-select--small,
.el-input--small {
  width: 100%;
}
</style>

